(function () {
  function cellsPerView(el) {
    if (window.matchMedia('(min-width: 990px)').matches) {
      return parseInt(el.dataset.cellsDesktop, 10) || 1;
    }
    if (window.matchMedia('(min-width: 600px)').matches) {
      return parseInt(el.dataset.cellsTablet, 10) || 1;
    }
    return parseInt(el.dataset.cellsMobile, 10) || 1;
  }

  function needsSlider(el) {
    var count = parseInt(el.dataset.cellsCount, 10) || 0;
    return count > cellsPerView(el);
  }

  function destroy(el) {
    if (el.dataset.flickityInit !== '1') return;
    if (typeof Flickity === 'undefined') return;
    var instance = Flickity.data(el);
    if (instance) instance.destroy();
    el.dataset.flickityInit = '';
  }

  function init(el) {
    if (!el || el.dataset.flickityInit === '1') return;
    if (typeof Flickity === 'undefined') return;

    el.dataset.flickityInit = '1';

    new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      groupCells: true,
      pageDots: false,
      prevNextButtons: true,
      freeScroll: false,
      imagesLoaded: true,
      dragThreshold: 10
    });
  }

  function sync(el) {
    if (needsSlider(el)) {
      init(el);
    } else {
      destroy(el);
    }
  }

  function syncAll(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-subcollections-slider]');
    sliders.forEach(sync);
  }

  function boot() {
    if (typeof Flickity === 'undefined') {
      window.addEventListener('load', function () { syncAll(); }, { once: true });
      return;
    }
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { syncAll(); }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('[data-subcollections-slider]');
    if (el) destroy(el);
  });
})();
